import { createSlice } from "@reduxjs/toolkit";
import Specialization from "../pages/admin/master/candidate-specialization/specialization";

const initialState = {
  jobPostFilterData: {
    companyName: "",
    jobType: 0,
    position: "",
    location: "",
    specialization: "",
    minSalary: 0,
    maxSalary: 0,
    minExperience: 0,
    maxExperience: 0,
    status: 1,
    skip: 0,
    take: 50,
  },
  candidateFilterData: {
    name: "",
    phoneNumber: "",
    location: "",
    gender: "",
    degreeName: "",
    jobExperience: 0,
    currentJobStatus: 0,
    minExperience: 0,
    maxExperience: 0,
    specialization: "",
    companyName: "",
    position: "",
    registrationStatus: 0,
    skills: "",
    minSalary: 0,
    maxSalary: 0,
    isDeleted: false,
    isCandidateAvailable: true,
    amountDue: false,
    skip: 0,
    take: 50,
    filterApplied: false,
  },
  currentPage: 0,
};

export const generalSlice = createSlice({
  name: "general",
  initialState,
  reducers: {
    setJobPostFilterData: (state, action) => {
      state.jobPostFilterData = action.payload;
    },
    setCandidateFilterData: (state, action) => {
      console.log(action.payload);
      state.candidateFilterData = action.payload;
    },
    setCurrentPage: (state, action) => {
      state.currentPage = action.payload;
    },
  },
});

// Action creators are generated for each case reducer function
export const { setJobPostFilterData, setCandidateFilterData, setCurrentPage } =
  generalSlice.actions;

export default generalSlice.reducer;
